const detailActionType = {
    SET_UUID:  'SET_UUID',
    SET_DETAIL_DATA:  'SET_DETAIL_DATA',
    SET_DETAIL_PAGE_PATH: 'SET_DETAIL_PAGE_PATH',
    SET_DETAIL_PRINT: 'SET_DETAIL_PRINT'
}

export default detailActionType;
